import { render, staticRenderFns } from "./hue-slider.vue?vue&type=template&id=2aacf11c&"
import script from "./hue-slider.vue?vue&type=script&lang=js&"
export * from "./hue-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports